import { Injectable } from '@angular/core';
import { ServiceBase } from './service-base';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpClient, HttpContext } from '@angular/common/http';
import { SHOW_SPINNER_HTTP_TOKEN } from '../../auth/auth.interceptor';
import { SchoolManagerBase } from './school-manager-base';
import { ApiConstants } from '../../_models/api-constants';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  static readonly NO_SPINNER_CONTEXT = new HttpContext().set(SHOW_SPINNER_HTTP_TOKEN, false);

  baseService: ServiceBase | null = null;
  schoolManagerService: SchoolManagerBase | null = null; // for common admin/schooladmin functions

  private images = new Map<number, any>();

  constructor(private http: HttpClient) {
  }

  public static replaceId(url: string, id: number): string {
    return url.replace('{id}', id.toString());
  }

  getResource(urlTemplate: string, resourceId: number): Observable<string | ArrayBuffer | null> {
    const images = this.images;

    const imageSubject = this.images.get(resourceId);

    return new Observable<string | ArrayBuffer | null>((observer) => {
      if (imageSubject != null) {
        imageSubject.subscribe(observer);
      } else {
        const url = CommonService.replaceId(urlTemplate, resourceId);

        // This is a tiny blank image
        const blank = 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
        let subject = new BehaviorSubject<string | ArrayBuffer | null>(blank);
        subject.subscribe(observer);
        images.set(resourceId, subject);

        // The next and error callbacks from the observer
        const {next, error} = observer;

        this.http.get(url, {responseType: 'blob', context: CommonService.NO_SPINNER_CONTEXT}).subscribe(response => {
          const reader = new FileReader();
          reader.readAsDataURL(response);
          reader.onloadend = function() {
            let subject = images.get(resourceId);
            subject.next(reader.result);
          };
        });
      }

      return { unsubscribe() {  } };
    });
  }

  static getPublicResourceUrl(id: number) :string {
    return CommonService.replaceId(ApiConstants.API_PUBLIC_ADDRESS_BASE + ApiConstants.API_PUBLIC_GET_RESOURCE, id);
  }

}
